// extracted by mini-css-extract-plugin
module.exports = {"field":"ContentField_field__1PIw8"};